var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.canInteract)?_c('div',{staticClass:"z-top row justify-center q-loading__indicator"},[_c('q-spinner-puff',{attrs:{"color":"primary","size":"14em"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }